import React, { useState, useCallback, useMemo } from "react";
import "../styles/report.css";
import Navbar from "./Navbar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Table from "./Table.js";
import TestChart from "./TestChart.js";
import useFetch from "./useFetch.js";
import swal from "sweetalert";
import axios from "axios";
import config from "../config.js";
import Cookie from "universal-cookie";
import mixpanel from "mixpanel-browser";

let shouldDisplayObject = {};

const Reports = () => {
  const cookies = new Cookie();
  let userToken = "";
  let actionInitiatingUser = -1;
  try {
    userToken = cookies.get("userToken");
    actionInitiatingUser = cookies.get("userID");
  } catch (error) {}

  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  const {
    data: views,
    isPending: isPendingViews,
    error: errorViews,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/views",
  });

  const [dataLogObject, setDataLogObject] = useState({});
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentView, setCurrentView] = useState(null);
  const [currentViewName, setCurrentViewName] = useState("");
  const [dataOptions, setDataOptions] = useState({
    limit: 10000,
    aggregate: false,
    interval: 5,
  });
  const [metadata, setMetadata] = useState(null);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [activeView, setActiveView] = useState("table");
  const [customDataLimit, setCustomDataLimit] = useState("");
  const [customInterval, setCustomInterval] = useState("");
  const [useCustomDataLimit, setUseCustomDataLimit] = useState(false);
  const [useCustomInterval, setUseCustomInterval] = useState(false);
  const [dataLimitError, setDataLimitError] = useState("");
  const [intervalError, setIntervalError] = useState("");
  const [metadataFetchStatus, setMetadataFetchStatus] = useState("idle");

  const processChartData = useCallback((responseData, view) => {
    if (!responseData || typeof responseData !== "object") {
      return { datasets: [] };
    }

    const chartDataSets = { datasets: [] };
    const sourceKeys = Object.keys(responseData);

    const colors = sourceKeys.map(
      (_, index) => `hsl(${(index * 137.5) % 360}, 70%, 50%)`
    );

    sourceKeys.forEach((source, index) => {
      const data = responseData[source];

      if (!Array.isArray(data) || data.length === 0) {
        return;
      }

      const validPoints = [];
      const invalidPoints = [];

      for (let i = 0; i < data.length; i++) {
        const point = data[i];

        if (!point || point.x === undefined || point.y === undefined) {
          continue;
        }

        const date = point.x instanceof Date ? point.x : new Date(point.x);
        if (isNaN(date.getTime())) {
          invalidPoints.push(point);
          continue;
        }

        let yValue = point.y;
        if (typeof yValue === "string") {
          yValue = parseFloat(yValue);
        }

        if (typeof yValue !== "number" || isNaN(yValue)) {
          invalidPoints.push(point);
          continue;
        }

        validPoints.push({ x: date, y: yValue });
      }

      if (invalidPoints.length > 0) {
        console.warn(
          `${source}: ${invalidPoints.length} invalid points out of ${data.length}`
        );
      }

      if (validPoints.length > 0) {
        const borderColor = colors[index];
        const backgroundColor = borderColor + "20";

        let decimationConfig = { enabled: false };
        if (validPoints.length > 2000) {
          decimationConfig = {
            enabled: true,
            algorithm: "lttb",
            samples: Math.min(1000, Math.floor(validPoints.length / 2)),
          };
        } else if (validPoints.length > 500) {
          decimationConfig = {
            enabled: true,
            algorithm: "min-max",
            samples: Math.min(500, Math.floor(validPoints.length / 1.5)),
          };
        }

        chartDataSets.datasets.push({
          label: source,
          borderColor,
          backgroundColor,
          data: validPoints,
          decimation: decimationConfig,
          pointRadius: validPoints.length > 1000 ? 0 : 2,
          pointHoverRadius: 4,
          borderWidth: 2,
          tension: 0.1,
          fill: false,
          _meta: {
            originalCount: data.length,
            validCount: validPoints.length,
            invalidCount: invalidPoints.length,
            decimated: decimationConfig.enabled,
          },
        });
      }
    });

    // console.log(`Chart data processed: ${chartDataSets.datasets.length} datasets, ` +
    //     `${chartDataSets.datasets.reduce((sum, ds) => sum + ds.data.length, 0)} total points`);

    return chartDataSets;
  }, []);

  //   const processTableData = useCallback((responseData) => {
  //       console.log(responseData)
  //       if (!responseData || typeof responseData !== 'object' || Object.keys(responseData).length === 0) {
  //           return { tableData: [], tableColumns: [] };
  //       }

  //       const normalizeTimestamp = (timestampStr) => {
  //           const date = new Date(timestampStr);
  //           date.setMilliseconds(0);
  //           return date.toISOString();
  //       };

  //       const timestampsSet = new Set();
  //       Object.keys(responseData).forEach(source => {
  //           responseData[source].forEach(dataPoint => {
  //               const normalizedTs = normalizeTimestamp(dataPoint.x);
  //               timestampsSet.add(normalizedTs);
  //           });
  //       });

  //       const timestamps = Array.from(timestampsSet)
  //           .map(ts => ({ original: ts, date: new Date(ts) }))
  //           .filter(ts => !isNaN(ts.date.getTime()))
  //           .sort((a, b) => a.date - b.date)
  //           .map(ts => ts.original);

  //       const sourceDataMap = {};
  //       Object.keys(responseData).forEach(source => {
  //           sourceDataMap[source] = {};
  //           responseData[source].forEach(dataPoint => {
  //               const normalizedTs = normalizeTimestamp(dataPoint.x);
  //               sourceDataMap[source][normalizedTs] = dataPoint.y;
  //           });
  //       });

  //       const tableData = timestamps.map(timestamp => {
  //           const date = new Date(timestamp);
  //           const formattedTimestamp = date.toLocaleString('en-GB', {
  //               day: '2-digit',
  //               month: '2-digit',
  //               year: 'numeric',
  //               hour: '2-digit',
  //               minute: '2-digit',
  //               second: '2-digit',
  //               hour12: false
  //           });

  //           const row = { timeStamp: formattedTimestamp };
  //           Object.keys(responseData).forEach(source => {
  //               const value = sourceDataMap[source][timestamp];
  //               // row[source] = (value !== undefined && value !== null) ? String(value) : '';
  //               // row[source] = (value !== undefined && value !== null)
  //               //     ? (typeof value === 'object' ? JSON.stringify(value) : String(value))
  //               //     : '';

  //               if (value && typeof value === 'object') {
  //                   for (const key in value) {
  //                       row[`${source}_${key}`] = value[key];
  //                   }
  //               } else {
  //                   row[source] = value ?? '';
  //               }

  //           });
  //           return row;
  //       });

  //       const tableColumns = [
  //           { title: "Timestamp", field: "timeStamp" },
  //           // ...Object.keys(responseData).map(column => ({
  //           //     title: column,
  //           //     field: column
  //           // }))
  //           ...Object.keys(responseData).flatMap(source => {
  //               const first = responseData[source][0]?.y;
  //               if (first && typeof first === 'object') {
  //                   return Object.keys(first).map(subKey => ({
  //                       title: `${source} ${subKey}`,
  //                       field: `${source}_${subKey}`
  //                   }));
  //               }
  //               return [{
  //                   title: source,
  //                   field: source
  //               }];
  //           })

  //       ];

  //       return { tableData, tableColumns };
  //   }, []);

  // const processTableData = useCallback((responseData) => {
  //   if (!responseData || typeof responseData !== "object") {
  //     return { tableData: [], tableColumns: [] };
  //   }
  //   console.log(responseData)

  //   // 🧩 Find the actual data array inside tableData (whatever key it has)
  //   const tableDataContainer = responseData;
  //     console.log(tableDataContainer)
  //   if (!tableDataContainer || typeof tableDataContainer !== "object") {
  //     return { tableData: [], tableColumns: [] };
  //   }

  //   // Get first array property (e.g., daata, records, users, etc.)
  //   const dataArray =
  //     Object.values(tableDataContainer).find((v) => Array.isArray(v)) || [];

  //   if (dataArray.length === 0) {
  //     return { tableData: [], tableColumns: [] };
  //   }

  //   // --- Helper: Flatten deeply nested objects ---
  //   const flattenObject = (obj, prefix = "") => {
  //     const flat = {};
  //     for (const key in obj) {
  //       if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
  //       const newKey = prefix ? `${prefix}_${key}` : key;
  //       const value = obj[key];
  //       if (typeof value === "object" && value !== null && !Array.isArray(value)) {
  //         Object.assign(flat, flattenObject(value, newKey));
  //       } else {
  //         flat[newKey] = value;
  //       }
  //     }
  //     return flat;
  //   };

  //   const allColumns = new Set();
  //   const rows = [];

  //   // --- Loop through entries ---
  //   dataArray.forEach((entry) => {
  //     const timestamp = entry.x
  //       ? new Date(entry.x).toLocaleString("en-GB", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: false,
  //         })
  //       : "";

  //     const yData = Array.isArray(entry.y)
  //       ? entry.y
  //       : entry.y && typeof entry.y === "object"
  //       ? [entry.y]
  //       : [];

  //     // --- Flatten and collect rows ---
  //     yData.forEach((item) => {
  //       const flatObj = flattenObject(item);
  //       flatObj.Timestamp = timestamp;
  //       rows.push(flatObj);
  //       Object.keys(flatObj).forEach((k) => allColumns.add(k));
  //     });
  //   });

  //   // --- Build columns dynamically ---
  //   const tableColumns = Array.from(allColumns)
  //     .sort((a, b) =>
  //       a === "Timestamp" ? -1 : b === "Timestamp" ? 1 : a.localeCompare(b)
  //     )
  //     .map((key) => ({
  //       title: key,
  //       field: key,
  //     }));

  //   // --- Fill missing keys for each row ---
  //   const tableData = rows.map((row) => {
  //     const complete = {};
  //     allColumns.forEach((k) => (complete[k] = row[k] ?? ""));
  //     return complete;
  //   });

  //   return { tableData, tableColumns };
  // }, []);

  // const processTableData = useCallback((responseData) => {
  //   if (!responseData || typeof responseData !== "object") {
  //     return { tableData: [], tableColumns: [] };
  //   }

  //   console.log(responseData);
  //   // 🧩 Try both cases: direct or nested under tableData
  //   const possibleContainer =
  //     responseData.tableData && typeof responseData.tableData === "object"
  //       ? responseData.tableData
  //       : responseData;

  //   // 🔍 Find the first array (e.g., daata, logs, results, etc.)
  //   const dataArray =
  //     Object.values(possibleContainer).find((v) => Array.isArray(v)) || [];

  //   if (dataArray.length === 0) {
  //     console.warn("No array found inside responseData");
  //     return { tableData: [], tableColumns: [] };
  //   }

  //   console.log(dataArray);
  //   // --- Flatten helper ---
  //   const flattenObject = (obj, prefix = "") => {
  //     const flat = {};
  //     if (!obj || typeof obj !== "object") return flat;
  //     for (const [key, value] of Object.entries(obj)) {
  //       const newKey = prefix ? `${prefix}_${key}` : key;
  //       if (
  //         typeof value === "object" &&
  //         value !== null &&
  //         !Array.isArray(value)
  //       ) {
  //         Object.assign(flat, flattenObject(value, newKey));
  //       } else {
  //         flat[newKey] = value;
  //       }
  //     }
  //     return flat;
  //   };

  //   const allColumns = new Set();
  //   const rows = [];

  //   // --- Parse each entry ---
  //   dataArray.forEach((entry) => {
  //     const timestamp = entry.x
  //       ? new Date(entry.x).toLocaleString("en-US", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: false,
  //         })
  //       : "";

  //     const y = entry.y;
  //     let yData = [];

  //     if (Array.isArray(y)) {
  //       yData = y;
  //     } else if (y && typeof y === "object") {
  //       yData = [y];
  //     } else {
  //       yData = [{ value: y }]; // primitive fallback
  //     }

  //     yData.forEach((item) => {
  //       const flatObj = flattenObject(item);
  //       flatObj.Timestamp = timestamp;
  //       rows.push(flatObj);
  //       Object.keys(flatObj).forEach((k) => allColumns.add(k));
  //     });
  //   });

  //   const tableColumns = Array.from(allColumns)
  //     .sort((a, b) =>
  //       a === "Timestamp" ? -1 : b === "Timestamp" ? 1 : a.localeCompare(b)
  //     )
  //     .map((key) => ({ title: key, field: key }));

  //   const tableData = rows.map((row) => {
  //     const filled = {};
  //     allColumns.forEach((k) => (filled[k] = row[k] ?? ""));
  //     return filled;
  //   });

  //   return { tableData, tableColumns };
  // }, []);

  const processTableData = useCallback((responseData) => {
    if (!responseData || typeof responseData !== "object") {
      return { tableData: [], tableColumns: [] };
    }

    const tableDataContainer =
      responseData.tableData && typeof responseData.tableData === "object"
        ? responseData.tableData
        : responseData;

    const streamKeys = Object.keys(tableDataContainer);

    if (streamKeys.length === 0) {
      return { tableData: [], tableColumns: [] };
    }

    // 🔧 flatten any nested object (recursive)
    const flatten = (obj, prefix = "") => {
      let out = {};

      for (const [key, value] of Object.entries(obj)) {
        const newKey = prefix ? `${prefix}_${key}` : key;

        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value)
        ) {
          Object.assign(out, flatten(value, newKey));
        } else {
          out[newKey] = value;
        }
      }

      return out;
    };

    // 🗂️ pivot table rows by timestamp
    const rowMap = new Map();

    for (const stream of streamKeys) {
      const rows = tableDataContainer[stream];
      if (!Array.isArray(rows)) continue;

      rows.forEach((entry) => {
        const ts = entry.x ? new Date(entry.x).toISOString() : null;
        if (!ts) return;

        // create base row
        if (!rowMap.has(ts)) rowMap.set(ts, { Timestamp: ts });

        const row = rowMap.get(ts);

        // Handle y-values based on primitive or object
        let y = entry.y;

        // Case 1: primitive → direct assignment
        if (typeof y !== "object" || y === null) {
          row[stream] = y; // testing: 68
        }

        // Case 2: object/array → flatten and merge
        else {
          const flatY = flatten(y, stream);
          Object.assign(row, flatY);
        }

        rowMap.set(ts, row);
      });
    }

    // convert rowMap → table array
    const tableData = Array.from(rowMap.values())
      .sort((a, b) => new Date(a.Timestamp) - new Date(b.Timestamp))
      .map((r) => ({
        ...r,
        Timestamp: new Date(r.Timestamp).toLocaleString("en-US", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }),
      }));

    // generate columns dynamically
    const columnNames = new Set();
    tableData.forEach((row) =>
      Object.keys(row).forEach((col) => columnNames.add(col))
    );

    const tableColumns = Array.from(columnNames).map((col) => ({
      title: col,
      field: col,
    }));

    return { tableColumns, tableData };
  }, []);

  const fetchMetadata = useCallback(
    async (viewId) => {
      setMetadataFetchStatus("loading");
      try {
        const response = await axios.get(
          `${config.BACKEND_URL}/views/${viewId}/metadata`,
          { headers }
        );
        setMetadata(response.data);
        setMetadataFetchStatus("success");

        const hasLargeDataset = Object.values(response.data).some(
          (source) => source.totalPoints > 10000
        );

        if (hasLargeDataset && !dataOptions.aggregate) {
          setShowAdvancedOptions(true);
        }
      } catch (err) {
        console.log("Failed to fetch metadata:", err);
        setMetadataFetchStatus("error");
        setErrorMessage(
          "Failed to fetch metadata. You can still try loading the data."
        );
      }
    },
    [headers, dataOptions.aggregate]
  );

  const validateDataLimit = (value) => {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue <= 0) {
      return "Data limit must be a positive number";
    }
    if (numValue > 1000000) {
      return "Data limit cannot exceed 1,000,000 points";
    }
    if (numValue < 100) {
      return "Data limit should be at least 100 points";
    }
    return "";
  };

  const validateInterval = (value) => {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue <= 0) {
      return "Interval must be a positive number";
    }
    if (numValue > 1440) {
      return "Interval cannot exceed 1440 minutes (24 hours)";
    }
    return "";
  };

  const handleCustomDataLimitChange = (e) => {
    const value = e.target.value;
    setCustomDataLimit(value);

    const error = validateDataLimit(value);
    setDataLimitError(error);

    if (!error && value !== "") {
      setDataOptions((prev) => ({
        ...prev,
        limit: parseInt(value),
      }));
    }
  };

  const handleCustomIntervalChange = (e) => {
    const value = e.target.value;
    setCustomInterval(value);

    const error = validateInterval(value);
    setIntervalError(error);

    if (!error && value !== "") {
      setDataOptions((prev) => ({
        ...prev,
        interval: parseInt(value),
      }));
    }
  };

  const handleUseCustomDataLimit = (checked) => {
    setUseCustomDataLimit(checked);
    if (!checked) {
      setCustomDataLimit("");
      setDataLimitError("");
      setDataOptions((prev) => ({ ...prev, limit: 10000 }));
    }
  };

  const handleUseCustomInterval = (checked) => {
    setUseCustomInterval(checked);
    if (!checked) {
      setCustomInterval("");
      setIntervalError("");
      setDataOptions((prev) => ({ ...prev, interval: 5 }));
    }
  };

  const handleDataOptionsChange = (key, value) => {
    setDataOptions((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "limit") {
      setUseCustomDataLimit(false);
      setCustomDataLimit("");
      setDataLimitError("");
    }
    if (key === "interval") {
      setUseCustomInterval(false);
      setCustomInterval("");
      setIntervalError("");
    }
  };

  const handleLoad = async (e) => {
    e.preventDefault();
    mixpanel.track("Report Page Load Button Clicked", {
      userID: cookies.get("userID"),
    });

    if (currentViewName === "") {
      swal(
        "View not selected!",
        "Select a view before it can be loaded.",
        "error"
      );
      return;
    }

    if (useCustomDataLimit && dataLimitError) {
      swal("Invalid Data Limit!", dataLimitError, "error");
      return;
    }

    if (useCustomInterval && intervalError) {
      swal("Invalid Interval!", intervalError, "error");
      return;
    }

    const view = views.find((view) => view.name === currentViewName);
    if (!view) {
      swal("View not found!", "The selected view does not exist.", "error");
      return;
    }

    setIsLoadingData(true);
    setDataLogObject({});
    setErrorMessage("");
    setCurrentView(view);

    try {
      if (!metadata) {
        await fetchMetadata(view.id);
      }

      const actionInitiatingUser = cookies.get("userID") || "unknown";
      const dataType =
        view.table && view.chart ? "both" : view.table ? "table" : "chart";
      const queryParams = new URLSearchParams({
        limit: dataOptions.limit.toString(),
        aggregate: dataOptions.aggregate.toString(),
        interval: dataOptions.interval.toString(),
        dataType: dataType,
      });

      const response = await axios.get(
        `${config.BACKEND_URL}/views/${view.id}/find_data?${queryParams}&actionInitiatingUser=${actionInitiatingUser}`,
        { headers }
      );

      const processedData = {};

      if (response.data.tableData) {
        const { tableData, tableColumns } = processTableData(
          response.data.tableData
        );
        processedData.tableData = tableData;
        processedData.tableColumns = tableColumns;
      }

      if (response.data.chartData) {
        processedData.chartData = processChartData(
          response.data.chartData,
          view
        );
      }

      shouldDisplayObject = {
        table: view.table,
        chart: view.chart,
      };
      processedData.shouldDisplay = shouldDisplayObject;
      setDataLogObject(processedData);

      if (view.table && view.chart) {
        setActiveView("table");
      } else if (view.table) {
        setActiveView("table");
      } else if (view.chart) {
        setActiveView("chart");
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status === 404) {
          setErrorMessage("View not found.");
        } else if (err.response.status === 400) {
          setErrorMessage("Invalid request.");
        } else if (err.response.status === 401) {
          setErrorMessage("Unauthorized. Please log in again.");
        } else {
          setErrorMessage("Failed to load data. Please try again later.");
        }
      } else {
        setErrorMessage("Network error. Please check your connection.");
      }
    } finally {
      setIsLoadingData(false);
    }
  };

  const handleReset = (e) => {
    mixpanel.track("Report Page Reset Button Clicked", {
      userID: cookies.get("userID"),
    });
    setCurrentViewName("");
    setCurrentView(null);
    setDataLogObject({});
    setErrorMessage("");
    setMetadata(null);
    setShowAdvancedOptions(false);
    setActiveView("table");
    setMetadataFetchStatus("idle");

    setCustomDataLimit("");
    setCustomInterval("");
    setUseCustomDataLimit(false);
    setUseCustomInterval(false);
    setDataLimitError("");
    setIntervalError("");

    setDataOptions({
      limit: 10000,
      aggregate: false,
      interval: 5,
    });
  };

  const setViewNameHandler = (e) => {
    e.persist();
    const name = e.target.value === "selectViewText" ? "" : e.target.value;
    setCurrentViewName(name);

    if (name === "") {
      setCurrentView(null);
      setDataLogObject({});
      setMetadata(null);
      setMetadataFetchStatus("idle");
    } else {
      const view = views.find((v) => v.name === name);
      setCurrentView(view);

      if (view) {
        shouldDisplayObject = {
          table: view.table,
          chart: view.chart,
        };
        setMetadataFetchStatus("loading");
        fetchMetadata(view.id);
      }
    }
  };

  const formatDateRange = () => {
    if (!currentView || !currentView.timeStamps) return "";
    const start = new Date(currentView.timeStamps.start)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
    const end = new Date(currentView.timeStamps.end)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
    return `${start}_to_${end}`;
  };

  const formatDateRangeForDisplay = () => {
    if (!currentView || !currentView.timeStamps) return "";
    const start = new Date(currentView.timeStamps.start).toLocaleDateString();
    const end = new Date(currentView.timeStamps.end).toLocaleDateString();
    return `${start} to ${end}`;
  };

  const metadataDisplay = useMemo(() => {
    if (!metadata) return null;

    const totalPoints = Object.values(metadata).reduce(
      (sum, source) => sum + source.totalPoints,
      0
    );

    return (
      <div className="alert alert-info">
        <strong>Data Overview:</strong> {totalPoints.toLocaleString()} total
        data points
        {totalPoints > 50000 && (
          <div className="mt-2">
            <small>
              ⚠️ Large dataset detected. Consider using aggregation for better
              performance.
            </small>
          </div>
        )}
      </div>
    );
  }, [metadata]);

  const isFormValid =
    !dataLimitError &&
    !intervalError &&
    (!useCustomDataLimit || customDataLimit !== "") &&
    (!useCustomInterval || customInterval !== "");

  const getAvailableViewOptions = () => {
    if (!currentView || !dataLogObject.shouldDisplay) return [];

    const options = [];
    if (
      dataLogObject.shouldDisplay.table &&
      dataLogObject.tableData?.length > 0
    ) {
      options.push({ key: "table", label: "Table View", icon: "📋" });
    }
    if (
      dataLogObject.shouldDisplay.chart &&
      dataLogObject.chartData?.datasets?.length > 0
    ) {
      options.push({ key: "chart", label: "Chart View", icon: "📊" });
    }
    if (options.length === 2) {
      options.push({ key: "both", label: "Both Views", icon: "📊📋" });
    }

    return options;
  };

  const availableViewOptions = getAvailableViewOptions();

  return (
    <div className="Reports">
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
      <Navbar />
      <main className="container-fluid px-4">
        <div className="row justify-content-center mb-4">
          <div className="col-lg-10">
            <div className="text-center mb-4">
              <h1 className="display-5 fw-bold mb-2">Reports Dashboard</h1>
              <p className="lead">
                Select a view and configure options to analyze your data
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            {errorMessage && (
              <div className="alert alert-danger mb-4">{errorMessage}</div>
            )}

            <div className="card shadow-sm mb-4">
              <div className="card-header bg-light">
                <h5 className="card-title mb-0">
                  <i className="material-icons align-middle me-2">view_list</i>
                  View Selection
                </h5>
              </div>
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    {isPendingViews && (
                      <div className="text-center">
                        <div
                          className="spinner-border text-primary me-2"
                          role="status"
                        ></div>
                        <span>Loading views...</span>
                      </div>
                    )}
                    {errorViews && (
                      <div className="alert alert-danger mb-0">
                        <i className="material-icons align-middle me-2">
                          error
                        </i>
                        Cannot fetch views right now!
                      </div>
                    )}
                    {views &&
                      !isPendingViews &&
                      (views.length === 0 ? (
                        <div className="alert alert-info mb-0">
                          <i className="material-icons align-middle me-2">
                            info
                          </i>
                          No views available.{" "}
                          <a href="/views/create" className="alert-link">
                            Create a new view
                          </a>
                        </div>
                      ) : (
                        <select
                          onChange={setViewNameHandler}
                          className="form-select form-select-lg"
                          name="views"
                          id="views"
                          aria-label="Select a view"
                          value={currentViewName}
                        >
                          <option value="selectViewText">
                            Choose a view...
                          </option>
                          {views.map((view, index) => (
                            <option key={index} value={view.name}>
                              {view.name}
                            </option>
                          ))}
                        </select>
                      ))}
                  </div>

                  {currentView && (
                    <div className="col-md-6 text-md-end mt-3 mt-md-0">
                      <div className="d-flex flex-wrap justify-content-md-end gap-2">
                        <span className="badge bg-primary fs-6 px-3 py-2">
                          <i
                            className="material-icons align-middle me-1"
                            style={{ fontSize: "16px" }}
                          >
                            date_range
                          </i>
                          {formatDateRangeForDisplay()}
                        </span>
                        {currentView.table && (
                          <span className="badge bg-success fs-6 px-2 py-2">
                            <i
                              className="material-icons align-middle"
                              style={{ fontSize: "16px" }}
                            >
                              table_chart
                            </i>
                          </span>
                        )}
                        {currentView.chart && (
                          <span className="badge bg-info fs-6 px-2 py-2">
                            <i
                              className="material-icons align-middle"
                              style={{ fontSize: "16px" }}
                            >
                              analytics
                            </i>
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {metadataFetchStatus === "loading" && (
                  <div className="text-center mt-2">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">
                        Loading metadata...
                      </span>
                    </div>
                    <p>Fetching metadata...</p>
                  </div>
                )}
                {metadataDisplay}
              </div>
            </div>

            {currentView && (
              <div className="card shadow-sm mb-4">
                <div className="card-header bg-light d-flex justify-content-between align-items-center">
                  <h6 className="card-title mb-0">
                    <i className="material-icons align-middle me-2">settings</i>
                    Data Configuration
                  </h6>
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                  >
                    <i
                      className="material-icons align-middle me-1"
                      style={{ fontSize: "16px" }}
                    >
                      {showAdvancedOptions ? "expand_less" : "expand_more"}
                    </i>
                    {showAdvancedOptions ? "Hide" : "Show"} Options
                  </button>
                </div>

                {showAdvancedOptions && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          <i
                            className="material-icons align-middle me-1"
                            style={{ fontSize: "18px" }}
                          >
                            data_usage
                          </i>
                          Max Data Points:
                        </label>

                        {!useCustomDataLimit ? (
                          <div>
                            <select
                              className="form-select mb-2"
                              value={dataOptions.limit}
                              onChange={(e) =>
                                handleDataOptionsChange(
                                  "limit",
                                  parseInt(e.target.value)
                                )
                              }
                            >
                              <option value={1000}>1,000</option>
                              <option value={5000}>5,000</option>
                              <option value={10000}>10,000</option>
                              <option value={25000}>25,000</option>
                              <option value={50000}>50,000</option>
                              <option value={100000}>100,000</option>
                            </select>
                            <div className="form-check">
                              <input
                                className="form-check-input-report"
                                type="checkbox"
                                id="useCustomDataLimit"
                                checked={useCustomDataLimit}
                                onChange={(e) =>
                                  handleUseCustomDataLimit(e.target.checked)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="useCustomDataLimit"
                              >
                                Use custom value
                              </label>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <input
                              type="number"
                              className={`form-control mb-2 ${
                                dataLimitError ? "is-invalid" : ""
                              }`}
                              placeholder="Enter custom data limit"
                              value={customDataLimit}
                              onChange={handleCustomDataLimitChange}
                              min="100"
                              max="1000000"
                            />
                            {dataLimitError && (
                              <div className="invalid-feedback">
                                {dataLimitError}
                              </div>
                            )}
                            <div className="form-check">
                              <input
                                className="form-check-input-report"
                                type="checkbox"
                                id="useCustomDataLimit"
                                checked={useCustomDataLimit}
                                onChange={(e) =>
                                  handleUseCustomDataLimit(e.target.checked)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="useCustomDataLimit"
                              >
                                Use predefined values
                              </label>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <div className="form-check form-switch mt-4">
                          <input
                            className="form-check-input-report"
                            type="checkbox"
                            id="aggregateData"
                            checked={dataOptions.aggregate}
                            onChange={(e) =>
                              handleDataOptionsChange(
                                "aggregate",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            className="form-check-label fw-semibold"
                            htmlFor="aggregateData"
                          >
                            <i
                              className="material-icons align-middle me-1"
                              style={{ fontSize: "18px" }}
                            >
                              compress
                            </i>
                            Aggregate Data (Charts Only)
                          </label>
                          <div className="form-text">
                            Groups data points by time intervals to improve
                            performance
                          </div>
                        </div>
                      </div>
                    </div>

                    {dataOptions.aggregate && (
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold">
                            <i
                              className="material-icons align-middle me-1"
                              style={{ fontSize: "18px" }}
                            >
                              schedule
                            </i>
                            Aggregation Interval:
                          </label>

                          {!useCustomInterval ? (
                            <div>
                              <select
                                className="form-select mb-2"
                                value={dataOptions.interval}
                                onChange={(e) =>
                                  handleDataOptionsChange(
                                    "interval",
                                    parseInt(e.target.value)
                                  )
                                }
                              >
                                <option value={1}>1 minute</option>
                                <option value={5}>5 minutes</option>
                                <option value={15}>15 minutes</option>
                                <option value={30}>30 minutes</option>
                                <option value={60}>1 hour</option>
                                <option value={120}>2 hours</option>
                                <option value={360}>6 hours</option>
                                <option value={720}>12 hours</option>
                              </select>
                              <div className="form-check">
                                <input
                                  className="form-check-input-report"
                                  type="checkbox"
                                  id="useCustomInterval"
                                  checked={useCustomInterval}
                                  onChange={(e) =>
                                    handleUseCustomInterval(e.target.checked)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="useCustomInterval"
                                >
                                  Use custom interval
                                </label>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <input
                                type="number"
                                className={`form-control mb-2 ${
                                  intervalError ? "is-invalid" : ""
                                }`}
                                placeholder="Enter custom interval"
                                value={customInterval}
                                onChange={handleCustomIntervalChange}
                                min="1"
                                max="1440"
                              />
                              {intervalError && (
                                <div className="invalid-feedback">
                                  {intervalError}
                                </div>
                              )}
                              <div className="form-check">
                                <input
                                  className="form-check-input-report"
                                  type="checkbox"
                                  id="useCustomInterval"
                                  checked={useCustomInterval}
                                  onChange={(e) =>
                                    handleUseCustomInterval(e.target.checked)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="useCustomInterval"
                                >
                                  Use predefined intervals
                                </label>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="d-flex justify-content-center gap-3 mb-4">
              <button
                className="btn btn-primary"
                onClick={handleLoad}
                disabled={
                  isLoadingData ||
                  !currentView ||
                  !isFormValid ||
                  metadataFetchStatus === "loading"
                }
              >
                {isLoadingData ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : (
                  "Load Data"
                )}
              </button>
              <button className="btn btn-secondary-reset" onClick={handleReset}>
                Reset
              </button>
            </div>

            {dataLogObject && dataLogObject.shouldDisplay && (
              <div className="card shadow-sm">
                <div className="card-header bg-light d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">
                    <i className="material-icons align-middle me-2">
                      visibility
                    </i>
                    Data Visualization
                  </h5>
                  <div className="btn-group">
                    {availableViewOptions.map((option) => (
                      <button
                        key={option.key}
                        type="button"
                        className={`btn btn-sm ${
                          activeView === option.key
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => setActiveView(option.key)}
                      >
                        {option.icon} {option.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="card-body">
                  {activeView === "table" || activeView === "both" ? (
                    dataLogObject.tableData?.length > 0 ? (
                      <div className="mb-4">
                        <h6>Table View</h6>
                        <Table
                          tableData={dataLogObject.tableData}
                          tableColumns={dataLogObject.tableColumns}
                          shouldModifySources={false}
                          shouldDownload={true}
                          isSelectable={false}
                          shouldDisplay={dataLogObject.shouldDisplay.table}
                          tableID="ReportsTable"
                          viewName={currentViewName}
                          viewID={currentView ? currentView.id : null}
                          httpHeaders={headers}
                          dateRange={formatDateRange()}
                        />
                      </div>
                    ) : (
                      <div className="alert alert-info mb-4">
                        No table data available.
                      </div>
                    )
                  ) : null}
                  {activeView === "chart" || activeView === "both" ? (
                    dataLogObject.chartData?.datasets?.length > 0 ? (
                      <div>
                        <h6>Chart View</h6>
                        <TestChart
                          datasets={dataLogObject.chartData.datasets}
                          chartID="ReportsChart"
                          shouldDisplay={dataLogObject.shouldDisplay.chart}
                          viewTimeRange={
                            currentView ? currentView.timeStamps : null
                          }
                        />
                      </div>
                    ) : (
                      <div className="alert alert-info">
                        No chart data available.
                      </div>
                    )
                  ) : null}
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Reports;
